<template>
  <v-dialog
    v-model="dialog"
    width="400px">
    <div class="dialog-container">
      <div class="dialog-header">
        <h4>Auto Renew</h4>
      </div>
      <div class="dialog-body flex">
        <el-form
          ref="form"
          :model="formData"
          :rules="rules">
          <div class="form-item type-button">
            <el-form-item
              ref="status"
              :rules="rules.select"
              prop="status">
              <v-radio-group
                v-model="formData.status"
                :list="turnList"/>
            </el-form-item>
          </div>
        </el-form>
      </div>

      <div class="dialog-footer">
        <div class="btn-group flex-sb">
          <v-button
            class="cancel"
            @click="handleCancel">Cancel</v-button>
          <v-button
            class="continue"
            @click="handleContinue">Confirm</v-button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'

export default {
  name: 'paid-status-dialog',
  mixins: [MixinOptions,MixinRules],
  props:{
    value:{
      type:Boolean,
      default:false
    },
    form:{
      type:Object,
      default:()=>({})
    },
    orderId: {
      type: [Number, String],
      default: 0
    },
  },
  data(){
    return{
      dialog: false,
      formData:{
        status:0,
      },
      turnList:[
        {
          id:0,
          name:'OFF'
        },
        {
          id:1,
          name:'ON'
        },
      ]
    }
  },
  watch:{
    value:{
      immediate:true,
      handler(val){
        this.dialog = val
      }
    }
  },
  methods: {
    handleContinue() {
      this.$refs.form.validate( (valid) => {
        if (valid) {
          this.$emit('next',this.formData)
          this.$emit('input', false)
        }
      })

    },
    handleCancel() {
      this.$emit('input', false)
    },
    network() {
      return {

      }
    }
  }
}
</script>
<style lang='scss' scoped>
/deep/.el-dialog{
  border-radius: 6px;
}
.dialog-container {
  .dialog-header{
    padding:16px;
    background: #F6F8FA;
    border: 1px solid #E1E4E8;
    border-radius: 6px 6px 0px 0px;
    h4 {
      font-weight: 600;
    }
  }
  .dialog-body{
    padding: 20px;
    flex-direction: column;
    .type-button {
      // margin-right: 20px;
      /deep/ .el-radio-group{
        display: flex;
      }
      ::v-deep .el-radio {
        //margin-right: 23px;
        margin-top: 8px;
        width: 50%;
        .el-radio__label {
          display: inline-block;
          //padding: 0px 10px;
          //height: auto;
          ////line-height: 30px;
          //font-size: 12px;
          //border-radius: 50px;
          //border: 1px solid #E1E4E8;
          //color: #24292E;
          //background: white;
          //font-weight: 500;
          //letter-spacing: 0;
          //line-height: 18px;
          //margin-left:8px ;
          //margin-right: 23px;
        }
      }
    }
    .el-button{
      width: 100%;
      margin-top: 20px;
      color: #0366D6;
      font-weight: 600;
      font-size: 14px;
      height: 32px;
      background: #FAFBFC;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
      border-radius: 6px;
      & + .el-button{
        margin-left: 0;
      }
    }
  }
  .dialog-footer{
    padding: 15px;
    padding-top: 0;
    .cancel{
      background: #FAFBFC;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
      border-radius: 6px;
    }
    .continue{
      background: #2EA44F;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.1);
      border-radius: 6px;
      color: #FFFFFF;
    }
  }
}
</style>
